<template>
  <div class="pt70">
    <section class="user-head" v-if="userInfo">
      <img
        :src="userInfo.icon ? userInfo.icon : '/static/img/mr-usericon.png'"
        alt=""
      />
      <div class="info">
        <h1>{{ userInfo.userName }}</h1>
        <div class="info-count">
          <div class="add-box">
            <el-button
              type="danger"
              round
              class="to-add-btn"
              @click="addTypeFlag = !addTypeFlag"
              :class="{ open: addTypeFlag }"
            >
              发布 <i class="el-icon-arrow-down"></i>
            </el-button>
            <ul class="classtify" v-show="addTypeFlag">
              <li @click="toAdd(1)">发文章</li>
              <li @click="toAdd(2)">发视频</li>
            </ul>
          </div>
        </div>
        <div class="info-des">
          <p>个性签名：{{ userInfo.intro }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
export default {
  name: "UserHeader",
  data() {
    return {
      userInfo: store.state.UserInfo
        ? store.state.UserInfo
        : JSON.parse(localStorage.getItem("UserInfo")),
      addTypeFlag: false,
    };
  },
  methods: {
    ...mapActions(["LOGIN", "GET_USERINFO"]),
    toAdd(i) {
      this.addTypeFlag = !this.addTypeFlag;
      const lcoalHref = window.location.href;
      i == 1
        ? lcoalHref.indexOf("/user/posts/add") > -1
          ? ""
          : this.$router.push("/user/posts/add")
        : i == 2
        ? lcoalHref.indexOf("/user/video/add") > -1
          ? ""
          : this.$router.push("/user/video/add")
        : lcoalHref.indexOf("/user/activety/add") > -1
        ? ""
        : this.$router.push("/user/activety/add");
    },
    getUserInfo() {
      this.GET_USERINFO()
        .then(() => {
          this.userInfo = JSON.parse(localStorage.getItem("UserInfo"));
        })
        .catch(() => {});
    },
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    window.addEventListener("storage", (e) => {
      if (e.key == "UserToken") {
        this.userToken = e.newValue;
      } else if (e.key == "UserInfo") {
        this.userInfo = e.newValue && JSON.parse(e.newValue);
      }
    });
  },
};
</script>

<style scoped lang="scss">
.user-head {
  width: 1000px;
  margin: 0px auto 10px;
  background: #fff;
  padding: 21px 40px;
  background: url("../assets/images/personal_bg.png") center no-repeat;
  display: flex;
  justify-content: flex-start !important;
  img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    margin-right: 20px;
  }
  .info {
    width: 780px;
    h1 {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 10px;
      line-height: 2;
    }
    .info-count {
      font-size: 15px;
      color: #333;
      margin-bottom: 15px;
      position: relative;
      span {
        margin-right: 55px;
        &:before {
          color: #b9b9b9;
          font-size: 17px;
          margin-right: 5px;
        }
        b {
          color: #121212;
          font-size: 18px;
          margin-left: 10px;
        }
      }
      .add-box {
        right: 0;
        top: -10px;
        position: absolute;
        z-index: 2;
        .to-add-btn {
          width: 124px;
          height: 40px;
          font-size: 16px;
          background: #317DFF url('../assets/images/pub-icon.png') no-repeat 27px center;
          background-size: 16px 16px;
          padding-left: 49px;
          i {
            transition: all 0.3s;
            transform-origin: center;
            font-size: 12px;
          }
          &.open {
            i {
              transform: rotate(180deg);
            }
          }
        }
        ul {
          width: 106px;
          margin: 8px auto;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
          border-radius: 2px;
          color: #535353;
          padding: 10px 0;
          background: #fff;
          text-align: center;
          line-height: 2;
          &::before{
            border-top:6px solid transparent;
            border-bottom:6px solid #fff;
            border-left:6px solid transparent;
            border-right:6px solid transparent;
            content: " ";
            display: block;
            height: 0;
            margin-top: -22px;
            width: 0;
            position: absolute;
            left: 50%;
            margin-left: -6px;
          }
          li {
            font-size: 15px;
            cursor: pointer;
            width: 100%;
            height: 36px;
            line-height: 36px;
            text-align: center;
            &:hover {
              background: #f5f5f5;
              color: #317DFF;
            }
          }
        }
      }
    }
    .info-des {
      p {
        font-size: 15px;
        line-height: 24px;
        color: #645c5c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserHead.vue